import hyperdom from 'hyperdom'
import formatPrice from '../../../packages/ui-helpers/formatPrice.js'
import * as gtmDataLayer from '../../../analytics/gtm/dataLayer.js'
import responsiveRender from '../../../responsiveRender.js'
import SectionComponentBase from './sectionComponentBase.jsx'

export default class PrepaidGratuities extends SectionComponentBase {
  constructor ({config, quoteCriteria}) {
    super({sectionName: 'prepaid-gratuities'})
    this.config = config
    this.quoteCriteria = quoteCriteria
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  hasPrepaidGratuities () {
    return this.quoteCriteria.passengers.some(passenger => passenger.prepaidGratuities)
  }

  render () {
    if (this.quoteCriteria.departure.prices.prepaidGratuities) {
      return <div className='gratuities'>
        <div className='o-accent-box'>
          <p className='gratuities__title'>Pre-pay gratuities for</p>
          {responsiveRender('small',
            () => this.renderMobile(),
            () => this.renderDesktop()
          )}
        </div>
      </div>
    }
  }

  renderDesktop () {
    return [
      <div className='o-inner-accent-box'>
        { this.renderPassengersList() }
      </div>,
    ]
  }

  renderMobile () {
    if (this.hasPrepaidGratuities()) {
      this.toggledForMobile = true
    }
    return [
      <div className={['discounts-offers__subtitle', 'u-margin-bottom-medium']}>Do you want to pre-pay gratuities for your whole trip?</div>,
      this.renderRadioButtons({
        onNoClick: () => this.quoteCriteria.passengers.forEach(p => delete p.prepaidGratuities),
      }),
      this.toggledForMobile ? this.renderPassengersList() : undefined,
    ]
  }

  renderPassengersList () {
    const {adultPrice, childPrice} = this.quoteCriteria.departure.prices.prepaidGratuities

    return <div className='gratuities__passengers'>
      {this.quoteCriteria.passengers.map((passenger, index) => {
        const price = passenger.type === 'adult' ? adultPrice : childPrice

        return <label className={['gratuities__passenger', 'o-choice-item', '-fullWidth']}>
          <input type='checkbox' className='o-choice-item__checkbox' binding={[passenger, 'prepaidGratuities']} />
          <div className='o-choice-item__content'>
            <span className={index === 0 ? 'passenger-name-semibold' : 'passenger-name'}>{passenger.fullName()}</span>
            <span> - </span>
            <strong className='price'>
              {formatPrice({
                currency: this.quoteCriteria.departure.prices.currency,
                amount: price,
              })}
            </strong>
          </div>
        </label>
      })}
    </div>
  }
}
